import React  from 'react'
// import TextField from '@material-ui/core/TextField';
// import Grid from '@material-ui/core/Grid';
// import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
// import { Link} from "react-router-dom";
import AppBar from "../../header/index"
import SignInButton from "../../button/globleButtons";
import AppProvider from "../../bootstrap/index";
import moment from "moment";
// import DateFnsUtils from "@date-io/date-fns";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
//   KeyboardTimePicker
// } from "@material-ui/pickers";
// import Calendar from 'material-ui/DatePicker/Calendar';
// import Calendar from "react-material-ui-calendar";
// import { Calendar } from '@material-ui/pickers'

const useStyles = makeStyles(theme => ({
    '@global': {
      body: {
        backgroundColor: theme.palette.common.white,
      },
    },
    paper: {
      // marginTop: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // width:"370"
    },
    avatar: {
      margin: 10,
      width: 300,
      height: 60,
      // margin: theme.spacing(1),
      backgroundColor: 'white',
    },
    form: {
      width: '110%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    TextField:{
      marginTop:"10%",
      backgroundColor:"#ffffff"
    },
    coverBackgroundContainer: {
      backgroundColor:"#F7F8F9",
      height: "100vh",
      backgroundSize: "cover",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      paddingLeft:"4%",
      paddingRight:"4%",
      paddingTop:"90px",
      paddingBottom:"20px"
    },
  }));
  
  const Date=()=>
  {
    
    // const classes = useStyles();
    let MeetUpDate;
    // let MeetUpTime;
    // const [isOpen, setIsOpen] = useState(true);
    const [selectedDate] = React.useState();
    const [selectedTime] = React.useState();
    // const [selectEndTime]=React.useState()
    console.log("selectedDate", selectedDate);
    console.log("selectedTime", selectedTime);
    MeetUpDate = moment(selectedDate).toISOString()
  console.log("MeetUpDate",MeetUpDate);
  return(<div></div>)
  // return(
  //   <MuiPickersUtilsProvider utils={DateFnsUtils}>
  //   <Grid container spacing={1}>
  //     <Grid item md={5}>
  //     <KeyboardDatePicker
  //                 margin="normal"
  //                 id="date-picker-dialog"
                
  //                 //  label="Choose a date for meeting"
  //                 //  format="DD/MM/YYYY"
  //                 fullWidth
  //                 value={selectedDate}
  //                 open={isOpen}
  //                 onOpen={() => setIsOpen(true)}
  //                 onClose={() => setIsOpen(false)}
  //                 onChange={(e)=>{
  //                   setSelectedDate(e);
                    
  //                 }}
  //                 KeyboardButtonProps={{
  //                   "aria-label": "change date"
  //                 }}
  //               />
                
  //       </Grid>
  //       <Grid item md={4}>
  //         <KeyboardTimePicker
  //                 margin="normal"
  //                 id="time-picker"
  //                 // label="From"
  //                 fullWidth
  //                 value={selectedTime}
  //                 onChange={(e)=>{
  //                   setSelectedTime(e);
  //                 }}
  //                 KeyboardButtonProps={{
  //                   "aria-label": "change time"
  //                 }}
  //               />
  //       </Grid>
  //       <Grid item md={3}>
  //          <KeyboardTimePicker
  //                 margin="normal"
  //                 id="time-picker"
  //                 // label="To"
  //                 fullWidth
  //                 value={selectEndTime}
  //                 onChange={(e)=>{
  //                   setselectEndTime(e);
  //                 }}
  //                 KeyboardButtonProps={{
  //                   "aria-label": "change time"
  //                 }}
  //               />
  //       </Grid>
  //          </Grid>
  //            </MuiPickersUtilsProvider>
  // )
  }
  const AvailabilityDate=(props)=>{
    const classes = useStyles();
    let MeetUpDate;
    // let MeetUpTime;
    // const [isOpen, setIsOpen] = useState(true);
    const [selectedDate, setSelectedDate] = React.useState();
    // const [selectedTime, setSelectedTime] = React.useState();
    // const [selectEndTime,setselectEndTime]=React.useState()
    console.log("selectedDate", selectedDate);
    // console.log("selectedTime", selectedTime);
    console.log("select",setSelectedDate)
    MeetUpDate = moment(selectedDate).toISOString()
  console.log("MeetUpDate",MeetUpDate)
    const {
      handleSubmit,
    } = props;
    return(
    <div className={classes.coverBackgroundContainer}>
     <AppProvider >
    <AppBar/>
    <Container component="main" maxWidth="xs" style={{background:"#ffffff",marginTop:"2%",}}>
    <div className={classes.paper} >
      

      <Typography component="h6" variant="h6" style={{paddingTop:"4%",}}>
         Define Your Availability
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
        <div ></div>
        
       <div style={{marginTop:"10%",marginBottom:"5%"}}>
         <SignInButton onClick={Date} buttonname="Add Schedule" />
         </div>
           </form>
         </div>
        
    </Container>
    {/* <div style={{marginTop:"2%",width:"100%"}}>
         <SignInButton  buttonname="Submit Schedule" />
         </div> */}
      </AppProvider>
        </div>
)


}
export default AvailabilityDate